const React = require('react');
const { createElement, Fragment } = React;

const InjectStyle = (Component, style) => (props) => createElement(
    Fragment,
    null,
    [
        createElement('style', { type: 'text/css' }, style),
        createElement(Component, props),
    ]
);

module.exports = InjectStyle;
